<template>
  <v-app-bar app :prominent="isMobile">
    <v-container class="pa-0">
      <v-row dense elevation="6">
        <v-col cols="auto">
          <v-btn icon @click="goBack">
            <v-icon>keyboard_arrow_left</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="auto">
          <user-avatar
            :size="50"
            :user="annualreview.user"
            color="performance"
            borderColor="performance"
            cssClass="halo text-h5"
            textColor="white"
          ></user-avatar>
        </v-col>
        <v-col cols="auto" class="mr-2">
          <div class="secondarytext--text font-weight-light">
            {{ annualreview.user.jobTitle }}
          </div>
          <div class="text-h6 font-weight-bold">
            {{ annualreview.user.fullName }}
          </div>
        </v-col>
        <v-spacer></v-spacer>
        <v-btn outlined x-large color="secondary" @click="showHistory">
          <v-icon class="mr-2">event_note</v-icon>
          Review History
        </v-btn>
      </v-row>
    </v-container>
    <template v-slot:extension>
      <v-tabs v-model="tab" centered color="performance">
        <v-tab>CoreBoard</v-tab>
        <v-tab>Q&A Review</v-tab>
        <v-tab>Sign Off</v-tab>
      </v-tabs>
    </template>
  </v-app-bar>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AnnualReviewAppBar",
  components: {},
  props: {},
  data: () => ({}),
  computed: {
    isComplete() {
      return this.annualreview.completeDate != null;
    },
    tab: {
      get() {
        return this.annualreview_tab;
      },
      set(val) {
        this.$store.dispatch("annualreview/setTab", val);
      }
    },
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    ...mapGetters({
      annualreview: "annualreview/annualreview",
      annualreview_tab: "annualreview/tab"
    })
  },
  methods: {
    goBack() {
      this.$router.push({ path: "/features/annual-reviews" });
    },
    showHistory() {
      this.$store.dispatch("annualreview/setDrawer", true);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-toolbar__content {
  background-color: #fff;
}
</style>
